import type { WizardStep } from '@/components/wizards';

import type { SeedWizardFormData } from './AddSeedByTypeModal.types';

/**
 * Step ID constants for switch statements.
 * Using constants prevents typo bugs and enables IDE autocomplete.
 */
export const STEP_IDS = {
  SELECT_TYPE: 'select-type',
  ADD_SEEDS: 'add-seeds',
} as const;

/**
 * Wizard step configuration for Add Seed modal.
 * Two-step wizard: type selection -> data entry.
 */
export const seedWizardSteps: WizardStep<SeedWizardFormData>[] = [
  {
    id: STEP_IDS.SELECT_TYPE,
    order: 1,
    title: 'Select Type',
    description: 'Choose the type of seed to add',
    validate: data => data.seedType !== null,
  },
  {
    id: STEP_IDS.ADD_SEEDS,
    order: 2,
    title: 'Add Seeds',
    description: 'Enter seed data or upload files',
    isFinal: true,
    // NOTE: Cannot fully validate here - file state is external.
    // Full validation handled by canSubmit in modal (Hybrid State Pattern).
    validate: () => true,
  },
];

/**
 * Initial form data for wizard.
 * Reset to these values when modal opens or wizard resets.
 */
export const DEFAULT_SEED_FORM_DATA: SeedWizardFormData = {
  seedType: null,
  textInput: '',
};
